import React, { useCallback, useState } from "react";

import { VimeoContainer } from "../components";
import { SHOW_INTERVIEW_ARCHIVE } from "../utils";
import { useStore } from "../store";
import "./Panorama.scss";

export default function Panorama() {
  const {
    media: { case_studies: caseStudyVideos, archive },
  } = useStore(
    useCallback((state) => {
      return state.data.media;
    }, [])
  );

  const CuratedStories = () => (
    <div className="flex flex-row flex-wrap h4 justify-center mb4">
      {caseStudyVideos.map((c) => (
        <VideoTile key={`case-study-video-${c.name}`} data={c} />
      ))}
    </div>
  );

  const InterviewArchives = () => (
    <div className="target-archive flex flex-row flex-wrap h4 justify-center mb4">
      {archive.map((c) => (
        <ArchiveRow
          key={`archive-video-${c.name}`}
          name={c.name}
          country={c.country}
          data={c}
        />
      ))}
    </div>
  );

  return (
    <div className="py-navbar">
      <div className="flex flex-column flex-wrap items-center block-font col-12 px1">
        <div>
          <div className="flex flex-column center items-center my4">
            <div className="h0 mb1">The Experience of Being Surveilled</div>
            <div className="color-gray h2">
              Human rights defenders targeted by NSO Group's Pegasus speak.
            </div>
          </div>
          <CuratedStories />
        </div>
        {SHOW_INTERVIEW_ARCHIVE && (
          <div>
            <div className="flex flex-column center items-center my4">
              <div className="h0 mb1">Interviews</div>
              <div className="color-gray h2">
                Voices of Targets and Investigators
              </div>
            </div>
            <InterviewArchives />
          </div>
        )}
      </div>
    </div>
  );
}

const ArchiveRow = ({ name = "", country = "", data = {} }) => {
  return (
    <div className="target-archive-row button__container flex flex-row flex-wrap h2 col-12 border-bottom px4 py2 border-x-hidden items-center">
      <div className="target-archive-row__name lg-col-3 sm-col-12 xs-col-12 col-12 bold">
        {name}
      </div>
      <div className="target-archive-row__country lg-col-2 sm-col-12 xs-col-12 col-12">
        {country}
      </div>
      <div className="target-archive-row__timecode flex color-gray lg-col-5 sm-col-12 xs-col-12 col-12">
        <div>
          {["x", "x", ":", "x", "x"].reduce(
            (acc, curr, idx) =>
              idx !== 2 ? acc + Math.floor(Math.random() * 6) : acc + curr,
            ""
          )}
        </div>
      </div>
      <div className="target-archive-row__poster flex flex-end justify-end lg-col-2">
        <div>
          <img src={data.poster} alt="target archive poster" />
        </div>
      </div>
    </div>
  );
};

const VideoTile = ({ data, noMetadata = false }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [, setShowControls] = useState(false);

  const onVideoPlay = useCallback(() => {
    setIsPlaying(true);
  }, []);

  const onTileHover = useCallback(() => {
    setShowControls(true);
  }, []);

  const onTileHoverOut = useCallback(() => {
    setShowControls(false);
  }, []);

  return (
    <div
      key={`case-study-video-${data.name}`}
      className="flex flex-column col-12 md-col-9 lg-col-12 p1 m1 block-font my2"
      onMouseOver={onTileHover}
      onMouseOut={onTileHoverOut}
    >
      <VimeoContainer
        onPlay={onVideoPlay}
        playing={isPlaying}
        controls
        width="100%"
        url={data.src}
      />
      {!noMetadata && (
        <div className="mt2 pointer h4 color-gray">{data.duration} mins</div>
      )}
      {!noMetadata && <div className="pointer h2">{data.name}</div>}
    </div>
  );
};
